import React, {
    useEffect,
    useState
} from "react";

import {
    Link
} from "react-router-dom";

import Swal from "sweetalert2";

import API_BASE_URL from "../config/api";


function Questions() {

    /*
    |--------------------------------------------------------------------------
    | API
    |--------------------------------------------------------------------------
    */

    const API_URL =
        `${API_BASE_URL}/admin/questions`;

    const CATEGORY_API_URL =
        `${API_BASE_URL}/admin/question-paper-categories`;

    const PAPERS_API_URL =
        `${API_BASE_URL}/admin/question-papers`;


    /*
    |--------------------------------------------------------------------------
    | Questions
    |--------------------------------------------------------------------------
    */

    const [questions, setQuestions] =
        useState([]);

    const [loading, setLoading] =
        useState(true);

    const [error, setError] =
        useState("");


    /*
    |--------------------------------------------------------------------------
    | Search
    |--------------------------------------------------------------------------
    */

    const [searchInput, setSearchInput] =
        useState("");

    const [search, setSearch] =
        useState("");

    const [appliedSearch, setAppliedSearch] =
        useState("");


    /*
    |--------------------------------------------------------------------------
    | Category / Paper Filter
    |--------------------------------------------------------------------------
    */

    const [categories, setCategories] =
        useState([]);

    const [papers, setPapers] =
        useState([]);

    const [selectedCategory, setSelectedCategory] =
        useState("");

    const [selectedPaper, setSelectedPaper] =
        useState("");

    /*
    | Applied values
    | These are the filters actually applied to questions.
    */

    const [appliedCategory, setAppliedCategory] =
        useState("");

    const [appliedPaper, setAppliedPaper] =
        useState("");


    /*
    |--------------------------------------------------------------------------
    | Pagination
    |--------------------------------------------------------------------------
    */

    const [currentPage, setCurrentPage] =
        useState(1);

    const [totalQuestions, setTotalQuestions] =
        useState(0);

    const [totalPages, setTotalPages] =
        useState(1);


    /*
    |--------------------------------------------------------------------------
    | Items Per Page
    |--------------------------------------------------------------------------
    */

    const itemsPerPage = 50;


    /*
    |--------------------------------------------------------------------------
    | Selected Questions
    |--------------------------------------------------------------------------
    */

    const [selectedQuestions, setSelectedQuestions] =
        useState([]);


    /*
    |--------------------------------------------------------------------------
    | Transfer Loading
    |--------------------------------------------------------------------------
    */

    const [transferLoading, setTransferLoading] =
        useState(false);


    /*
    |--------------------------------------------------------------------------
    | Transfer To Question
    |--------------------------------------------------------------------------
    */

    const [showTransferBox, setShowTransferBox] =
        useState(false);

    const [transferCategory, setTransferCategory] =
        useState("");

    const [transferPaper, setTransferPaper] =
        useState("");

    const [transferCategories, setTransferCategories] =
        useState([]);

    const [transferPapers, setTransferPapers] =
        useState([]);


    /*
    |--------------------------------------------------------------------------
    | Transfer To MCQ
    |--------------------------------------------------------------------------
    */

    const [showMcqTransferBox, setShowMcqTransferBox] =
        useState(false);

    const [transferMcqCategory, setTransferMcqCategory] =
        useState("");

    const [transferMcqPaper, setTransferMcqPaper] =
        useState("");

    const [transferMcqCategories, setTransferMcqCategories] =
        useState([]);

    const [transferMcqPapers, setTransferMcqPapers] =
        useState([]);


    /*
    |--------------------------------------------------------------------------
    | Remove HTML
    |--------------------------------------------------------------------------
    */

    const getText = (html) => {

        if (!html) {
            return "";
        }

        const tempDiv =
            document.createElement("div");

        tempDiv.innerHTML = html;

        return (
            tempDiv.textContent ||
            tempDiv.innerText ||
            ""
        ).trim();

    };


    /*
    |--------------------------------------------------------------------------
    | Fetch Categories
    |--------------------------------------------------------------------------
    */

    const fetchCategories = async () => {

        try {

            const response =
                await fetch(
                    CATEGORY_API_URL,
                    {
                        method: "GET",

                        headers: {
                            Accept:
                                "application/json"
                        },

                        credentials:
                            "include"
                    }
                );


            if (
                response.status === 401
            ) {

                throw new Error(
                    "Admin authentication failed. Please login again."
                );

            }


            const data =
                await response.json();


            console.log(
                "QUESTION FILTER CATEGORIES:",
                data
            );


            if (!response.ok) {

                throw new Error(
                    data.message ||
                    "Unable to load categories."
                );

            }


            setCategories(
                Array.isArray(data.data)
                    ? data.data
                    : []
            );

        } catch (error) {

            console.error(
                "CATEGORY FILTER ERROR:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Error",

                text:
                    error.message ||
                    "Unable to load categories."

            });

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Fetch Papers By Category
    |--------------------------------------------------------------------------
    */

    const fetchPapersByCategory = async (
        category
    ) => {

        setSelectedPaper("");

        setPapers([]);


        if (!category) {

            return;

        }


        try {

            const response =
                await fetch(

                    `${PAPERS_API_URL}/${encodeURIComponent(category)}`,

                    {

                        method: "GET",

                        headers: {

                            Accept:
                                "application/json"

                        },

                        credentials:
                            "include"

                    }

                );


            if (
                response.status === 401
            ) {

                throw new Error(
                    "Admin authentication failed. Please login again."
                );

            }


            const data =
                await response.json();


            console.log(
                "QUESTION FILTER PAPERS:",
                data
            );


            if (!response.ok) {

                throw new Error(

                    data.message ||
                    "Unable to load papers."

                );

            }


            setPapers(

                Array.isArray(
                    data.papers
                )
                    ? data.papers
                    : []

            );


        } catch (error) {

            console.error(
                "PAPER FILTER ERROR:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Error",

                text:
                    error.message ||
                    "Unable to load papers."

            });

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Fetch Questions
    |--------------------------------------------------------------------------
    */

    const fetchQuestions = async (
        page = currentPage,
        searchValue = appliedSearch,
        categoryValue = appliedCategory,
        paperValue = appliedPaper
    ) => {

        try {

            setLoading(true);

            setError("");


            /*
            |----------------------------------------------------------------------
            | Build Query
            |----------------------------------------------------------------------
            */

            const params =
                new URLSearchParams();


            params.append(
                "page",
                page
            );


            params.append(
                "per_page",
                itemsPerPage
            );


            if (
                searchValue &&
                searchValue.trim()
            ) {

                params.append(
                    "search",
                    searchValue.trim()
                );

            }


            if (
                categoryValue &&
                categoryValue.trim()
            ) {

                params.append(
                    "category",
                    categoryValue
                );

            }


            if (
                paperValue
            ) {

                params.append(
                    "paper_id",
                    paperValue
                );

            }


            /*
            |----------------------------------------------------------------------
            | Request
            |----------------------------------------------------------------------
            */

            const response =
                await fetch(

                    `${API_URL}?${params.toString()}`,

                    {

                        method: "GET",

                        headers: {

                            Accept:
                                "application/json"

                        },

                        credentials:
                            "include"

                    }

                );


            /*
            |----------------------------------------------------------------------
            | Authentication
            |----------------------------------------------------------------------
            */

            if (
                response.status === 401
            ) {

                throw new Error(
                    "Admin authentication failed. Please login again."
                );

            }


            /*
            |----------------------------------------------------------------------
            | JSON
            |----------------------------------------------------------------------
            */

            const data =
                await response.json();


            console.log(
                "Questions API Response:",
                data
            );


            /*
            |----------------------------------------------------------------------
            | HTTP Error
            |----------------------------------------------------------------------
            */

            if (!response.ok) {

                throw new Error(

                    data.message ||
                    `Server Error: ${response.status}`

                );

            }


            /*
            |----------------------------------------------------------------------
            | Success
            |----------------------------------------------------------------------
            */

            if (data.success) {

                /*
                |------------------------------------------------------------------
                | Questions
                |------------------------------------------------------------------
                */

                setQuestions(

                    Array.isArray(
                        data.questions
                    )
                        ? data.questions
                        : []

                );


                /*
                |------------------------------------------------------------------
                | Pagination
                |------------------------------------------------------------------
                */

                const pagination =
                    data.pagination || {};


                setTotalQuestions(

                    Number(
                        pagination.total || 0
                    )

                );


                setTotalPages(

                    Number(
                        pagination.last_page || 1
                    )

                );


                setCurrentPage(

                    Number(
                        pagination.current_page ||
                        page
                    )

                );

            } else {

                setQuestions([]);

                setTotalQuestions(0);

                setTotalPages(1);

                setError(

                    data.message ||
                    "Unable to fetch questions."

                );

            }


        } catch (error) {

            console.error(
                "Questions API Error:",
                error
            );


            setQuestions([]);

            setTotalQuestions(0);

            setTotalPages(1);


            setError(

                error.message ||
                "Unable to connect with server."

            );


        } finally {

            setLoading(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Initial Load
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        fetchCategories();

        fetchQuestions(
            1,
            "",
            "",
            ""
        );

    }, []);


    /*
    |--------------------------------------------------------------------------
    | Search Handler
    |--------------------------------------------------------------------------
    */

    const handleSearch = (event) => {

        setSearchInput(
            event.target.value
        );

    };


    /*
    |--------------------------------------------------------------------------
    | Category Change
    |--------------------------------------------------------------------------
    */

    const handleCategoryChange = async (
        event
    ) => {

        const category =
            event.target.value;


        setSelectedCategory(
            category
        );


        setSelectedPaper("");


        /*
        | Important:
        | Do NOT fetch questions here.
        | Only load papers.
        */

        await fetchPapersByCategory(
            category
        );

    };


    /*
    |--------------------------------------------------------------------------
    | Apply Filter
    |--------------------------------------------------------------------------
    */

    const handleFilter = () => {

        setSearch(
            searchInput
        );


        setAppliedSearch(
            searchInput
        );


        setAppliedCategory(
            selectedCategory
        );


        setAppliedPaper(
            selectedPaper
        );


        setCurrentPage(1);


        fetchQuestions(

            1,

            searchInput,

            selectedCategory,

            selectedPaper

        );

    };


    /*
    |--------------------------------------------------------------------------
    | Reset Filter
    |--------------------------------------------------------------------------
    */

    const handleReset = () => {

        setSearchInput("");

        setSearch("");

        setAppliedSearch("");

        setSelectedCategory("");

        setSelectedPaper("");

        setAppliedCategory("");

        setAppliedPaper("");

        setPapers([]);

        setCurrentPage(1);


        fetchQuestions(
            1,
            "",
            "",
            ""
        );

    };


    /*
    |--------------------------------------------------------------------------
    | Select Question
    |--------------------------------------------------------------------------
    */

    const handleQuestionSelect = (
        questionId
    ) => {

        setSelectedQuestions(
            (previous) => {

                if (
                    previous.includes(
                        questionId
                    )
                ) {

                    return previous.filter(
                        (id) =>
                            id !== questionId
                    );

                }


                return [

                    ...previous,

                    questionId

                ];

            }
        );

    };


    /*
    |--------------------------------------------------------------------------
    | Delete Question
    |--------------------------------------------------------------------------
    */

    const handleDeleteQuestion = async (
        questionId
    ) => {

        if (!questionId) {

            Swal.fire({

                icon: "error",

                title: "Error",

                text:
                    "Question ID is missing."

            });

            return;

        }


        const confirmation =
            await Swal.fire({

                icon: "warning",

                title: "Delete Question?",

                html: `

                    <p class="mb-2">
                        Are you sure you want to delete this question?
                    </p>

                    <p class="text-danger mb-0">
                        <strong>
                            This action cannot be undone.
                        </strong>
                    </p>

                `,

                showCancelButton: true,

                confirmButtonText:
                    "Yes, Delete",

                cancelButtonText:
                    "Cancel",

                confirmButtonColor:
                    "#dc3545",

                cancelButtonColor:
                    "#6c757d",

                reverseButtons: true

            });


        if (
            !confirmation.isConfirmed
        ) {

            return;

        }


        try {

            setTransferLoading(true);


            const response =
                await fetch(

                    `${API_URL}/${encodeURIComponent(questionId)}`,

                    {

                        method: "DELETE",

                        headers: {

                            Accept:
                                "application/json"

                        },

                        credentials:
                            "include"

                    }

                );


            if (
                response.status === 401
            ) {

                throw new Error(
                    "Admin authentication failed. Please login again."
                );

            }


            const data =
                await response.json();


            console.log(
                "DELETE QUESTION RESPONSE:",
                data
            );


            if (!response.ok) {

                throw new Error(

                    data.message ||
                    `Server Error: ${response.status}`

                );

            }


            if (!data.success) {

                throw new Error(

                    data.message ||
                    "Unable to delete question."

                );

            }


            setSelectedQuestions(
                (previous) =>
                    previous.filter(
                        (id) =>
                            id !== questionId
                    )
            );


            await Swal.fire({

                icon: "success",

                title: "Deleted",

                text:
                    data.message ||
                    "Question deleted successfully.",

                confirmButtonText:
                    "OK"

            });


            await fetchQuestions(

                currentPage,

                appliedSearch,

                appliedCategory,

                appliedPaper

            );


        } catch (error) {

            console.error(
                "DELETE QUESTION ERROR:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Delete Failed",

                text:
                    error.message ||
                    "Unable to delete question."

            });

        } finally {

            setTransferLoading(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Select All Current Page
    |--------------------------------------------------------------------------
    */

    const handleSelectAll = () => {

        const currentPageIds =
            questions.map(
                (question) =>
                    question.question_id
            );


        const allSelected =
            currentPageIds.length > 0 &&
            currentPageIds.every(
                (id) =>
                    selectedQuestions.includes(id)
            );


        if (allSelected) {

            setSelectedQuestions(

                (previous) =>

                    previous.filter(
                        (id) =>
                            !currentPageIds.includes(id)
                    )

            );

        } else {

            setSelectedQuestions(

                (previous) => {

                    const newIds =
                        currentPageIds.filter(
                            (id) =>
                                !previous.includes(id)
                        );


                    return [

                        ...previous,

                        ...newIds

                    ];

                }

            );

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Current Page Selected
    |--------------------------------------------------------------------------
    */

    const isCurrentPageFullySelected =

        questions.length > 0 &&

        questions.every(
            (question) =>

                selectedQuestions.includes(
                    question.question_id
                )
        );


    /*
    |--------------------------------------------------------------------------
    | Previous Page
    |--------------------------------------------------------------------------
    */

    const handlePrevious = () => {

        if (
            currentPage > 1
        ) {

            const page =
                currentPage - 1;


            setCurrentPage(page);


            fetchQuestions(

                page,

                appliedSearch,

                appliedCategory,

                appliedPaper

            );

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Next Page
    |--------------------------------------------------------------------------
    */

    const handleNext = () => {

        if (
            currentPage < totalPages
        ) {

            const page =
                currentPage + 1;


            setCurrentPage(page);


            fetchQuestions(

                page,

                appliedSearch,

                appliedCategory,

                appliedPaper

            );

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Go To Page
    |--------------------------------------------------------------------------
    */

    const goToPage = (
        page
    ) => {

        if (
            page >= 1 &&
            page <= totalPages
        ) {

            setCurrentPage(page);


            fetchQuestions(

                page,

                appliedSearch,

                appliedCategory,

                appliedPaper

            );

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Page Numbers
    |--------------------------------------------------------------------------
    */

    const getPageNumbers = () => {

        const pages = [];

        const maxVisiblePages = 5;


        if (
            totalPages <= maxVisiblePages
        ) {

            for (
                let i = 1;
                i <= totalPages;
                i++
            ) {

                pages.push(i);

            }

            return pages;

        }


        pages.push(1);


        let start =
            Math.max(
                2,
                currentPage - 1
            );


        let end =
            Math.min(
                totalPages - 1,
                currentPage + 1
            );


        if (
            currentPage <= 3
        ) {

            start = 2;

            end = 4;

        }


        if (
            currentPage >=
            totalPages - 2
        ) {

            start =
                totalPages - 3;

            end =
                totalPages - 1;

        }


        if (
            start > 2
        ) {

            pages.push("...");

        }


        for (
            let i = start;
            i <= end;
            i++
        ) {

            pages.push(i);

        }


        if (
            end <
            totalPages - 1
        ) {

            pages.push("...");

        }


        pages.push(
            totalPages
        );


        return pages;

    };


    /*
    |--------------------------------------------------------------------------
    | Transfer Categories
    |--------------------------------------------------------------------------
    */

    const fetchTransferCategories =
        async () => {

            try {

                const response =
                    await fetch(

                        `${API_BASE_URL}/admin/question-paper-categories`,

                        {

                            method: "GET",

                            headers: {

                                Accept:
                                    "application/json"

                            },

                            credentials:
                                "include"

                        }

                    );


                if (
                    response.status === 401
                ) {

                    throw new Error(
                        "Admin authentication failed. Please login again."
                    );

                }


                const data =
                    await response.json();


                console.log(
                    "QUESTION TRANSFER CATEGORIES:",
                    data
                );


                if (!response.ok) {

                    throw new Error(

                        data.message ||
                        "Unable to load categories."

                    );

                }


                setTransferCategories(

                    Array.isArray(
                        data.data
                    )
                        ? data.data
                        : []

                );


            } catch (error) {

                console.error(
                    "TRANSFER CATEGORY ERROR:",
                    error
                );


                Swal.fire({

                    icon: "error",

                    title: "Error",

                    text:
                        error.message ||
                        "Unable to load categories."

                });

            }

        };


    /*
    |--------------------------------------------------------------------------
    | Transfer Papers
    |--------------------------------------------------------------------------
    */

    const fetchTransferPapers =
        async (
            category
        ) => {

            setTransferPaper("");

            setTransferPapers([]);


            if (!category) {

                return;

            }


            try {

                const response =
                    await fetch(

                        `${API_BASE_URL}/admin/question-papers/${encodeURIComponent(category)}`,

                        {

                            method: "GET",

                            headers: {

                                Accept:
                                    "application/json"

                            },

                            credentials:
                                "include"

                        }

                    );


                if (
                    response.status === 401
                ) {

                    throw new Error(
                        "Admin authentication failed. Please login again."
                    );

                }


                const data =
                    await response.json();


                console.log(
                    "QUESTION TRANSFER PAPERS:",
                    data
                );


                if (!response.ok) {

                    throw new Error(

                        data.message ||
                        "Unable to load papers."

                    );

                }


                setTransferPapers(

                    Array.isArray(
                        data.papers
                    )
                        ? data.papers
                        : []

                );


            } catch (error) {

                console.error(
                    "TRANSFER PAPERS ERROR:",
                    error
                );


                Swal.fire({

                    icon: "error",

                    title: "Error",

                    text:
                        error.message ||
                        "Unable to load papers."

                });

            }

        };


    /*
    |--------------------------------------------------------------------------
    | Open Transfer Box
    |--------------------------------------------------------------------------
    */

    const openTransferBox =
        async () => {

            if (
                selectedQuestions.length === 0
            ) {

                Swal.fire({

                    icon: "warning",

                    title:
                        "No Question Selected",

                    text:
                        "Please select at least one question."

                });

                return;

            }


            setShowMcqTransferBox(false);

            setShowTransferBox(true);

            setTransferCategory("");

            setTransferPaper("");

            setTransferPapers([]);


            await fetchTransferCategories();

        };


    /*
    |--------------------------------------------------------------------------
    | Close Transfer Box
    |--------------------------------------------------------------------------
    */

    const closeTransferBox = () => {

        if (
            transferLoading
        ) {

            return;

        }


        setShowTransferBox(false);

        setTransferCategory("");

        setTransferPaper("");

        setTransferPapers([]);

    };


    /*
    |--------------------------------------------------------------------------
    | MCQ Subjects
    |--------------------------------------------------------------------------
    */

    const fetchMcqTransferCategories =
        async () => {

            try {

                const response =
                    await fetch(

                        `${API_BASE_URL}/admin/question-transfer/mcq-subjects`,

                        {

                            method: "GET",

                            headers: {

                                Accept:
                                    "application/json"

                            },

                            credentials:
                                "include"

                        }

                    );


                if (
                    response.status === 401
                ) {

                    throw new Error(
                        "Admin authentication failed. Please login again."
                    );

                }


                const data =
                    await response.json();


                console.log(
                    "MCQ SUBJECTS RESPONSE:",
                    data
                );


                if (!response.ok) {

                    throw new Error(

                        data.message ||
                        "Unable to load subjects."

                    );

                }


                setTransferMcqCategories(

                    Array.isArray(
                        data.subjects
                    )
                        ? data.subjects
                        : []

                );


            } catch (error) {

                console.error(
                    "MCQ SUBJECT ERROR:",
                    error
                );


                Swal.fire({

                    icon: "error",

                    title: "Error",

                    text:
                        error.message ||
                        "Unable to load subjects."

                });

            }

        };


    /*
    |--------------------------------------------------------------------------
    | MCQ Papers
    |--------------------------------------------------------------------------
    */

    const fetchMcqTransferPapers =
        async (
            subject
        ) => {

            setTransferMcqPaper("");

            setTransferMcqPapers([]);


            if (!subject) {

                return;

            }


            try {

                const response =
                    await fetch(

                        `${API_BASE_URL}/admin/question-transfer/mcq-papers?subject=${encodeURIComponent(subject)}`,

                        {

                            method: "GET",

                            headers: {

                                Accept:
                                    "application/json"

                            },

                            credentials:
                                "include"

                        }

                    );


                if (
                    response.status === 401
                ) {

                    throw new Error(
                        "Admin authentication failed. Please login again."
                    );

                }


                const data =
                    await response.json();


                console.log(
                    "MCQ PAPERS RESPONSE:",
                    data
                );


                if (!response.ok) {

                    throw new Error(

                        data.message ||
                        "Unable to load MCQ papers."

                    );

                }


                setTransferMcqPapers(

                    Array.isArray(
                        data.papers
                    )
                        ? data.papers
                        : []

                );


            } catch (error) {

                console.error(
                    "MCQ PAPERS ERROR:",
                    error
                );


                Swal.fire({

                    icon: "error",

                    title: "Error",

                    text:
                        error.message ||
                        "Unable to load MCQ papers."

                });

            }

        };


    /*
    |--------------------------------------------------------------------------
    | Open MCQ Transfer
    |--------------------------------------------------------------------------
    */

    const openMcqTransferBox =
        async () => {

            if (
                selectedQuestions.length === 0
            ) {

                Swal.fire({

                    icon: "warning",

                    title:
                        "No Question Selected",

                    text:
                        "Please select at least one question."

                });

                return;

            }


            setShowTransferBox(false);

            setShowMcqTransferBox(true);

            setTransferMcqCategory("");

            setTransferMcqPaper("");

            setTransferMcqPapers([]);


            await fetchMcqTransferCategories();

        };


    /*
    |--------------------------------------------------------------------------
    | Close MCQ Transfer
    |--------------------------------------------------------------------------
    */

    const closeMcqTransferBox = () => {

        if (
            transferLoading
        ) {

            return;

        }


        setShowMcqTransferBox(false);

        setTransferMcqCategory("");

        setTransferMcqPaper("");

        setTransferMcqPapers([]);

    };


    /*
    |--------------------------------------------------------------------------
    | Transfer To Question
    |--------------------------------------------------------------------------
    */

    const handleTransferToQuestion =
        async () => {

            if (
                selectedQuestions.length === 0
            ) {

                Swal.fire({

                    icon: "warning",

                    title:
                        "No Question Selected",

                    text:
                        "Please select at least one question."

                });

                return;

            }


            if (!transferCategory) {

                Swal.fire({

                    icon: "warning",

                    title:
                        "Select Category",

                    text:
                        "Please select a category."

                });

                return;

            }


            if (!transferPaper) {

                Swal.fire({

                    icon: "warning",

                    title:
                        "Select Paper",

                    text:
                        "Please select a paper."

                });

                return;

            }


            const confirmation =
                await Swal.fire({

                    icon:
                        "question",

                    title:
                        "Transfer Questions?",

                    html:
                        `

                        <p>
                            You have selected
                            <strong>
                                ${selectedQuestions.length}
                            </strong>
                            question(s).
                        </p>

                        <p class="mb-0">
                            Transfer them to the selected question paper?
                        </p>

                        `,

                    showCancelButton:
                        true,

                    confirmButtonText:
                        "Yes, Transfer",

                    cancelButtonText:
                        "Cancel",

                    reverseButtons:
                        true

                });


            if (
                !confirmation.isConfirmed
            ) {

                return;

            }


            try {

                setTransferLoading(
                    true
                );


                const response =
                    await fetch(

                        `${API_BASE_URL}/admin/question-transfer/to-question`,

                        {

                            method:
                                "POST",

                            headers: {

                                "Content-Type":
                                    "application/json",

                                Accept:
                                    "application/json"

                            },

                            credentials:
                                "include",

                            body:
                                JSON.stringify({

                                    question_ids:
                                        selectedQuestions,

                                    paper_id:
                                        transferPaper

                                })

                        }

                    );


                const data =
                    await response.json();


                console.log(
                    "TRANSFER TO QUESTION RESPONSE:",
                    data
                );


                if (!response.ok) {

                    throw new Error(

                        data.message ||
                        "Unable to transfer questions."

                    );

                }


                if (!data.success) {

                    throw new Error(

                        data.message ||
                        "Unable to transfer questions."

                    );

                }


                await Swal.fire({

                    icon:
                        "success",

                    title:
                        "Transfer Successful",

                    text:
                        data.message ||
                        "Questions transferred successfully.",

                    confirmButtonText:
                        "OK"

                });


                setSelectedQuestions([]);


                closeTransferBox();


                await fetchQuestions(

                    currentPage,

                    appliedSearch,

                    appliedCategory,

                    appliedPaper

                );


            } catch (error) {

                console.error(
                    "TRANSFER TO QUESTION ERROR:",
                    error
                );


                Swal.fire({

                    icon:
                        "error",

                    title:
                        "Transfer Failed",

                    text:
                        error.message ||
                        "Unable to transfer questions."

                });


            } finally {

                setTransferLoading(
                    false
                );

            }

        };


    /*
    |--------------------------------------------------------------------------
    | Transfer To MCQ
    |--------------------------------------------------------------------------
    */

    const handleTransferToMCQ =
        async () => {

            if (
                selectedQuestions.length === 0
            ) {

                Swal.fire({

                    icon:
                        "warning",

                    title:
                        "No Question Selected",

                    text:
                        "Please select at least one question."

                });

                return;

            }


            if (!transferMcqCategory) {

                Swal.fire({

                    icon:
                        "warning",

                    title:
                        "Select Subject",

                    text:
                        "Please select a subject."

                });

                return;

            }


            if (!transferMcqPaper) {

                Swal.fire({

                    icon:
                        "warning",

                    title:
                        "Select Paper",

                    text:
                        "Please select an MCQ paper."

                });

                return;

            }


            const confirmation =
                await Swal.fire({

                    icon:
                        "question",

                    title:
                        "Transfer Questions?",

                    html:
                        `

                        <p>
                            You have selected
                            <strong>
                                ${selectedQuestions.length}
                            </strong>
                            question(s).
                        </p>

                        <p class="mb-0">
                            Transfer them to the selected MCQ paper?
                        </p>

                        `,

                    showCancelButton:
                        true,

                    confirmButtonText:
                        "Yes, Transfer",

                    cancelButtonText:
                        "Cancel",

                    reverseButtons:
                        true

                });


            if (
                !confirmation.isConfirmed
            ) {

                return;

            }


            try {

                setTransferLoading(
                    true
                );


                const response =
                    await fetch(

                        `${API_BASE_URL}/admin/question-transfer/to-mcq`,

                        {

                            method:
                                "POST",

                            headers: {

                                "Content-Type":
                                    "application/json",

                                Accept:
                                    "application/json"

                            },

                            credentials:
                                "include",

                            body:
                                JSON.stringify({

                                    question_ids:
                                        selectedQuestions,

                                    subject:
                                        transferMcqCategory,

                                    paper_id:
                                        transferMcqPaper

                                })

                        }

                    );


                const data =
                    await response.json();


                console.log(
                    "TRANSFER TO MCQ RESPONSE:",
                    data
                );


                if (!response.ok) {

                    throw new Error(

                        data.message ||
                        "Unable to transfer questions."

                    );

                }


                if (!data.success) {

                    throw new Error(

                        data.message ||
                        "Unable to transfer questions."

                    );

                }


                await Swal.fire({

                    icon:
                        "success",

                    title:
                        "Transfer Successful",

                    text:
                        data.message ||
                        "Questions transferred to MCQ successfully.",

                    confirmButtonText:
                        "OK"

                });


                setSelectedQuestions([]);


                closeMcqTransferBox();


                await fetchQuestions(

                    currentPage,

                    appliedSearch,

                    appliedCategory,

                    appliedPaper

                );


            } catch (error) {

                console.error(
                    "TRANSFER TO MCQ ERROR:",
                    error
                );


                Swal.fire({

                    icon:
                        "error",

                    title:
                        "Transfer Failed",

                    text:
                        error.message ||
                        "Unable to transfer questions."

                });


            } finally {

                setTransferLoading(
                    false
                );

            }

        };


    /*
    |--------------------------------------------------------------------------
    | Showing Numbers
    |--------------------------------------------------------------------------
    */

    const startNumber =
        totalQuestions === 0
            ? 0
            : (
                (currentPage - 1) *
                itemsPerPage
            ) + 1;


    const endNumber =
        totalQuestions === 0
            ? 0
            : Math.min(

                currentPage *
                itemsPerPage,

                totalQuestions

            );


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    if (loading) {

        return (

            <div
                className="
                    container-fluid
                    d-flex
                    justify-content-center
                    align-items-center
                "
                style={{
                    minHeight:
                        "400px"
                }}
            >

                <div
                    className="text-center"
                >

                    <div
                        className="
                            spinner-border
                            text-primary
                        "
                        role="status"
                    >
                    </div>


                    <div
                        className="
                            mt-3
                            text-muted
                        "
                    >

                        Loading questions...

                    </div>

                </div>

            </div>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | Main
    |--------------------------------------------------------------------------
    */

    return (

        <div
            className="container-fluid"
            style={{
                maxHeight:
                    "85vh",

                overflowY:
                    "auto"
            }}
        >


            {/* =========================================================
                PAGE HEADER
            ========================================================= */}

            <div
                className="
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-4
                    flex-wrap
                    gap-2
                "
            >

                <div>

                    <h3 className="mb-1">
                        Questions
                    </h3>

                    <p
                        className="
                            text-muted
                            mb-0
                        "
                    >

                        Manage questions and paper details

                    </p>

                </div>


                <div
                    className="
                        d-flex
                        gap-2
                        flex-wrap
                    "
                >

                    <span
                        className="
                            badge
                            bg-light
                            text-dark
                            border
                            d-flex
                            align-items-center
                            px-3
                        "
                    >

                        Selected:
                        {" "}
                        {selectedQuestions.length}

                    </span>


                    <button
                        type="button"
                        className="btn btn-success"
                        disabled={
                            selectedQuestions.length === 0 ||
                            transferLoading
                        }
                        onClick={
                            openTransferBox
                        }
                    >

                        <i
                            className="
                                fa
                                fa-copy
                                me-2
                            "
                        ></i>

                        Transfer to Question

                    </button>


                    <button
                        type="button"
                        className="btn btn-warning"
                        disabled={
                            selectedQuestions.length === 0 ||
                            transferLoading
                        }
                        onClick={
                            openMcqTransferBox
                        }
                    >

                        <i
                            className="
                                fa
                                fa-book
                                me-2
                            "
                        ></i>

                        Transfer to MCQ Question

                    </button>


                    <button
                        type="button"
                        className="
                            btn
                            btn-outline-primary
                        "
                        onClick={() =>
                            fetchQuestions(

                                currentPage,

                                appliedSearch,

                                appliedCategory,

                                appliedPaper

                            )
                        }
                        disabled={
                            transferLoading
                        }
                    >

                        <i
                            className="
                                fa
                                fa-refresh
                                me-2
                            "
                        ></i>

                        Refresh

                    </button>


                    <Link
                        to="/add-question"
                        className="btn btn-primary"
                    >

                        <i
                            className="
                                fa
                                fa-plus
                                me-2
                            "
                        ></i>

                        Add Question

                    </Link>

                </div>

            </div>


            {/* =========================================================
                TRANSFER TO QUESTION
            ========================================================= */}

            {showTransferBox && (

                <div
                    className="
                        card
                        shadow-sm
                        mb-4
                        border-success
                    "
                >

                    <div
                        className="
                            card-header
                            bg-success
                            text-white
                            d-flex
                            justify-content-between
                            align-items-center
                        "
                    >

                        <div>

                            <strong>
                                Transfer Questions
                            </strong>

                            <span className="ms-2">

                                (
                                {selectedQuestions.length}
                                {" "}
                                selected
                                )

                            </span>

                        </div>

                    </div>


                    <div className="card-body">

                        <div className="row">


                            <div
                                className="
                                    col-md-4
                                    mb-3
                                "
                            >

                                <label
                                    className="
                                        form-label
                                        fw-semibold
                                    "
                                >

                                    Select Category

                                </label>


                                <select
                                    className="form-select"
                                    value={
                                        transferCategory
                                    }
                                    onChange={(e) => {

                                        const value =
                                            e.target.value;

                                        setTransferCategory(
                                            value
                                        );

                                        fetchTransferPapers(
                                            value
                                        );

                                    }}
                                    disabled={
                                        transferLoading
                                    }
                                >

                                    <option value="">

                                        -----Select Paper Category-----

                                    </option>


                                    {transferCategories.map(
                                        (
                                            category,
                                            index
                                        ) => {

                                            const categoryValue =
                                                category.paper ||
                                                category.category ||
                                                category.name ||
                                                "";

                                            const categoryLabel =
                                                category.paper ||
                                                category.category ||
                                                category.name ||
                                                "";

                                            return (

                                                <option
                                                    key={
                                                        category.id ||
                                                        index
                                                    }
                                                    value={
                                                        categoryValue
                                                    }
                                                >

                                                    {
                                                        categoryLabel
                                                    }

                                                </option>

                                            );

                                        }
                                    )}

                                </select>

                            </div>


                            <div
                                className="
                                    col-md-4
                                    mb-3
                                "
                            >

                                <label
                                    className="
                                        form-label
                                        fw-semibold
                                    "
                                >

                                    Select Paper

                                </label>


                                <select
                                    className="form-select"
                                    value={
                                        transferPaper
                                    }
                                    onChange={(e) =>
                                        setTransferPaper(
                                            e.target.value
                                        )
                                    }
                                    disabled={
                                        !transferCategory ||
                                        transferLoading
                                    }
                                >

                                    <option value="">

                                        {
                                            transferCategory
                                                ? "-----Select Paper-----"
                                                : "-----Select Category First-----"
                                        }

                                    </option>


                                    {transferPapers.map(
                                        (
                                            paper,
                                            index
                                        ) => {

                                            const paperId =
                                                paper.paper_id ||
                                                paper.id ||
                                                "";

                                            const paperName =
                                                paper.paper ||
                                                paper.name ||
                                                `Paper ${paperId}`;

                                            return (

                                                <option
                                                    key={
                                                        paperId ||
                                                        index
                                                    }
                                                    value={
                                                        paperId
                                                    }
                                                >

                                                    {
                                                        paperName
                                                    }

                                                </option>

                                            );

                                        }
                                    )}

                                </select>

                            </div>

                        </div>


                        <div className="mt-2">

                            <button
                                type="button"
                                className="
                                    btn
                                    btn-success
                                    me-2
                                "
                                disabled={
                                    !transferCategory ||
                                    !transferPaper ||
                                    transferLoading
                                }
                                onClick={
                                    handleTransferToQuestion
                                }
                            >

                                {transferLoading ? (

                                    <>

                                        <span
                                            className="
                                                spinner-border
                                                spinner-border-sm
                                                me-2
                                            "
                                        ></span>

                                        Processing...

                                    </>

                                ) : (

                                    <>

                                        <i
                                            className="
                                                fa
                                                fa-check
                                                me-2
                                            "
                                        ></i>

                                        SUBMIT

                                    </>

                                )}

                            </button>


                            <button
                                type="button"
                                className="
                                    btn
                                    btn-danger
                                "
                                onClick={
                                    closeTransferBox
                                }
                                disabled={
                                    transferLoading
                                }
                            >

                                <i
                                    className="
                                        fa
                                        fa-times
                                        me-2
                                    "
                                ></i>

                                Cancel

                            </button>

                        </div>

                    </div>

                </div>

            )}


            {/* =========================================================
                TRANSFER TO MCQ
            ========================================================= */}

            {showMcqTransferBox && (

                <div
                    className="
                        card
                        shadow-sm
                        mb-4
                        border-warning
                    "
                >

                    <div
                        className="
                            card-header
                            bg-warning
                            d-flex
                            justify-content-between
                            align-items-center
                        "
                    >

                        <div>

                            <strong>
                                Transfer to MCQ Question
                            </strong>

                            <span className="ms-2">

                                (
                                {selectedQuestions.length}
                                {" "}
                                selected
                                )

                            </span>

                        </div>

                    </div>


                    <div className="card-body">

                        <div className="row">


                            <div
                                className="
                                    col-md-4
                                    mb-3
                                "
                            >

                                <label
                                    className="
                                        form-label
                                        fw-semibold
                                    "
                                >

                                    Select Subject

                                </label>


                                <select
                                    className="form-select"
                                    value={
                                        transferMcqCategory
                                    }
                                    onChange={(e) => {

                                        const value =
                                            e.target.value;

                                        setTransferMcqCategory(
                                            value
                                        );

                                        fetchMcqTransferPapers(
                                            value
                                        );

                                    }}
                                    disabled={
                                        transferLoading
                                    }
                                >

                                    <option value="">

                                        -----Select Subject-----

                                    </option>


                                    {transferMcqCategories.map(
                                        (
                                            subject,
                                            index
                                        ) => {

                                            const subjectValue =
                                                subject.subject ||
                                                subject.name ||
                                                subject.value ||
                                                subject ||
                                                "";

                                            const subjectLabel =
                                                subject.subject ||
                                                subject.name ||
                                                subject.value ||
                                                subject ||
                                                "";

                                            return (

                                                <option
                                                    key={
                                                        subject.id ||
                                                        index
                                                    }
                                                    value={
                                                        subjectValue
                                                    }
                                                >

                                                    {
                                                        subjectLabel
                                                    }

                                                </option>

                                            );

                                        }
                                    )}

                                </select>

                            </div>


                            <div
                                className="
                                    col-md-4
                                    mb-3
                                "
                            >

                                <label
                                    className="
                                        form-label
                                        fw-semibold
                                    "
                                >

                                    Select Paper

                                </label>


                                <select
                                    className="form-select"
                                    value={
                                        transferMcqPaper
                                    }
                                    onChange={(e) =>
                                        setTransferMcqPaper(
                                            e.target.value
                                        )
                                    }
                                    disabled={
                                        !transferMcqCategory ||
                                        transferLoading
                                    }
                                >

                                    <option value="">

                                        {
                                            transferMcqCategory
                                                ? "-----Select Paper-----"
                                                : "-----Select Subject First-----"
                                        }

                                    </option>


                                    {transferMcqPapers.map(
                                        (
                                            paper,
                                            index
                                        ) => {

                                            const paperId =
                                                paper.paper_id ||
                                                paper.id ||
                                                paper.paper ||
                                                "";

                                            const paperName =
                                                paper.paper ||
                                                paper.name ||
                                                String(
                                                    paperId
                                                );

                                            return (

                                                <option
                                                    key={
                                                        `${paperId}-${index}`
                                                    }
                                                    value={
                                                        paperId
                                                    }
                                                >

                                                    {
                                                        paperName
                                                    }

                                                </option>

                                            );

                                        }
                                    )}

                                </select>

                            </div>

                        </div>


                        <div className="mt-2">

                            <button
                                type="button"
                                className="
                                    btn
                                    btn-warning
                                    me-2
                                "
                                disabled={
                                    !transferMcqCategory ||
                                    !transferMcqPaper ||
                                    transferLoading
                                }
                                onClick={
                                    handleTransferToMCQ
                                }
                            >

                                {transferLoading ? (

                                    <>

                                        <span
                                            className="
                                                spinner-border
                                                spinner-border-sm
                                                me-2
                                            "
                                        ></span>

                                        Processing...

                                    </>

                                ) : (

                                    <>

                                        <i
                                            className="
                                                fa
                                                fa-check
                                                me-2
                                            "
                                        ></i>

                                        SUBMIT

                                    </>

                                )}

                            </button>


                            <button
                                type="button"
                                className="
                                    btn
                                    btn-danger
                                "
                                onClick={
                                    closeMcqTransferBox
                                }
                                disabled={
                                    transferLoading
                                }
                            >

                                <i
                                    className="
                                        fa
                                        fa-times
                                        me-2
                                    "
                                ></i>

                                Cancel

                            </button>

                        </div>

                    </div>

                </div>

            )}


            {/* =========================================================
                ERROR
            ========================================================= */}

            {error && (

                <div
                    className="
                        alert
                        alert-danger
                        d-flex
                        justify-content-between
                        align-items-center
                    "
                >

                    <span>
                        {error}
                    </span>


                    <button
                        type="button"
                        className="
                            btn
                            btn-sm
                            btn-danger
                        "
                        onClick={() =>
                            fetchQuestions(

                                currentPage,

                                appliedSearch,

                                appliedCategory,

                                appliedPaper

                            )
                        }
                    >

                        Try Again

                    </button>

                </div>

            )}


            {/* =========================================================
                MAIN CARD
            ========================================================= */}

            <div className="card shadow-sm">


                {/* =====================================================
                    CARD HEADER / FILTER
                ===================================================== */}

                <div
                    className="
                        card-header
                        bg-white
                    "
                >

                    <div className="row g-3 align-items-end">


                        {/* SEARCH */}

                        <div
                            className="
                                col-lg-4
                                col-md-6
                            "
                        >

                            <label
                                className="
                                    form-label
                                    fw-semibold
                                "
                            >

                                Search

                            </label>


                            <div
                                className="
                                    input-group
                                "
                            >

                                <span
                                    className="
                                        input-group-text
                                        bg-white
                                    "
                                >

                                    <i
                                        className="
                                            fa
                                            fa-search
                                        "
                                    ></i>

                                </span>


                                <input
                                    type="text"
                                    className="
                                        form-control
                                    "
                                    placeholder="
                                        Search question, Q number, paper or category...
                                    "
                                    value={
                                        searchInput
                                    }
                                    onChange={
                                        handleSearch
                                    }
                                    onKeyDown={(event) => {

                                        if (
                                            event.key ===
                                            "Enter"
                                        ) {

                                            handleFilter();

                                        }

                                    }}
                                />

                            </div>

                        </div>


                        {/* CATEGORY */}

                        <div
                            className="
                                col-lg-3
                                col-md-6
                            "
                        >

                            <label
                                className="
                                    form-label
                                    fw-semibold
                                "
                            >

                                Category

                            </label>


                            <select
                                className="
                                    form-select
                                "
                                value={
                                    selectedCategory
                                }
                                onChange={
                                    handleCategoryChange
                                }
                            >

                                <option value="">

                                    ----- All Categories -----

                                </option>


                                {categories.map(
                                    (
                                        category,
                                        index
                                    ) => {

                                        const categoryValue =
                                            category.paper ||
                                            category.category ||
                                            category.name ||
                                            "";

                                        return (

                                            <option
                                                key={
                                                    category.id ||
                                                    category.category_id ||
                                                    index
                                                }
                                                value={
                                                    categoryValue
                                                }
                                            >

                                                {
                                                    categoryValue
                                                }

                                            </option>

                                        );

                                    }
                                )}

                            </select>

                        </div>


                        {/* PAPER */}

                        <div
                            className="
                                col-lg-3
                                col-md-6
                            "
                        >

                            <label
                                className="
                                    form-label
                                    fw-semibold
                                "
                            >

                                Paper

                            </label>


                            <select
                                className="
                                    form-select
                                "
                                value={
                                    selectedPaper
                                }
                                onChange={(event) =>
                                    setSelectedPaper(
                                        event.target.value
                                    )
                                }
                                disabled={
                                    !selectedCategory
                                }
                            >

                                <option value="">

                                    {
                                        selectedCategory
                                            ? "----- All Papers -----"
                                            : "----- Select Category First -----"
                                    }

                                </option>


                                {papers.map(
                                    (
                                        paper,
                                        index
                                    ) => {

                                        const paperId =
                                            paper.paper_id ||
                                            paper.id ||
                                            "";

                                        return (

                                            <option
                                                key={
                                                    paperId ||
                                                    index
                                                }
                                                value={
                                                    paperId
                                                }
                                            >

                                                {
                                                    paper.paper
                                                }

                                                {
                                                    paper.paper_type
                                                        ? ` - ${paper.paper_type}`
                                                        : ""
                                                }

                                            </option>

                                        );

                                    }
                                )}

                            </select>

                        </div>


                        {/* FILTER BUTTONS */}

                        <div
                            className="
                                col-lg-2
                                col-md-6
                                d-flex
                                gap-2
                            "
                        >

                            <button
                                type="button"
                                className="
                                    btn
                                    btn-primary
                                    flex-grow-1
                                "
                                onClick={
                                    handleFilter
                                }
                            >

                                <i
                                    className="
                                        fa
                                        fa-filter
                                        me-2
                                    "
                                ></i>

                                Filter

                            </button>


                            <button
                                type="button"
                                className="
                                    btn
                                    btn-outline-secondary
                                "
                                onClick={
                                    handleReset
                                }
                                title="
                                    Reset Filters
                                "
                            >

                                <i
                                    className="
                                        fa
                                        fa-refresh
                                    "
                                ></i>
                                Reset

                            </button>

                        </div>

                    </div>


                    {/* =================================================
                        APPLIED FILTER INFORMATION
                    ================================================= */}

                    {(appliedSearch ||
                        appliedCategory ||
                        appliedPaper) && (

                        <div
                            className="
                                mt-3
                                d-flex
                                align-items-center
                                flex-wrap
                                gap-2
                            "
                        >

                            <span
                                className="
                                    text-muted
                                    fw-semibold
                                "
                            >

                                Applied Filters:

                            </span>


                            {appliedSearch && (

                                <span
                                    className="
                                        badge
                                        bg-primary
                                    "
                                >

                                    Search:
                                    {" "}
                                    {appliedSearch}

                                </span>

                            )}


                            {appliedCategory && (

                                <span
                                    className="
                                        badge
                                        bg-success
                                    "
                                >

                                    Category:
                                    {" "}
                                    {appliedCategory}

                                </span>

                            )}


                            {appliedPaper && (

                                <span
                                    className="
                                        badge
                                        bg-warning
                                        text-dark
                                    "
                                >

                                    Paper ID:
                                    {" "}
                                    {appliedPaper}

                                </span>

                            )}

                        </div>

                    )}


                    {/* =================================================
                        TOTAL
                    ================================================= */}

                    <div
                        className="
                            mt-3
                            d-flex
                            justify-content-between
                            align-items-center
                            flex-wrap
                        "
                    >

                        <div>

                            <span
                                className="text-muted"
                            >

                                Total Questions:

                            </span>


                            <strong
                                className="ms-2"
                            >

                                {
                                    totalQuestions
                                }

                            </strong>

                        </div>


                        {selectedQuestions.length > 0 && (

                            <div
                                className="
                                    text-success
                                "
                            >

                                Selected:

                                {" "}

                                <strong>

                                    {
                                        selectedQuestions.length
                                    }

                                </strong>

                            </div>

                        )}

                    </div>

                </div>


                {/* =====================================================
                    TABLE
                ===================================================== */}

                <div
                    className="
                        card-body
                        p-0
                    "
                >

                    <div
                        className="
                            table-responsive
                        "
                        style={{
                            maxHeight:
                                "320px"
                        }}
                    >

                        <table
                            className="
                                table
                                table-bordered
                                table-hover
                                align-middle
                                mb-0
                            "
                        >

                            <thead
                                className="table-light"
                                style={{
                                    position:
                                        "sticky",

                                    top: 0,

                                    zIndex: 5
                                }}
                            >

                                <tr>

                                    <th
                                        className="
                                            text-center
                                        "
                                        style={{
                                            minWidth:
                                                "70px"
                                        }}
                                    >

                                        <input
                                            type="checkbox"
                                            className="
                                                form-check-input
                                            "
                                            checked={
                                                isCurrentPageFullySelected
                                            }
                                            onChange={
                                                handleSelectAll
                                            }
                                            title="
                                                Select all questions on this page
                                            "
                                        />

                                    </th>


                                    <th
                                        className="
                                            text-center
                                        "
                                        style={{
                                            minWidth:
                                                "60px"
                                        }}
                                    >

                                        #

                                    </th>


                                    <th
                                        className="
                                            text-center
                                        "
                                        style={{
                                            minWidth:
                                                "100px"
                                        }}
                                    >

                                        Q. Number

                                    </th>


                                    <th
                                        style={{
                                            minWidth:
                                                "400px"
                                        }}
                                    >

                                        Question

                                    </th>


                                    <th
                                        style={{
                                            minWidth:
                                                "110px"
                                        }}
                                    >

                                        Paper Type

                                    </th>


                                    <th
                                        style={{
                                            minWidth:
                                                "150px"
                                        }}
                                    >

                                        Paper

                                    </th>


                                    <th
                                        style={{
                                            minWidth:
                                                "180px"
                                        }}
                                    >

                                        Category

                                    </th>


                                    <th
                                        style={{
                                            minWidth:
                                                "130px"
                                        }}
                                    >

                                        Exam Date

                                    </th>


                                    <th
                                        className="
                                            text-center
                                        "
                                        style={{
                                            minWidth:
                                                "100px"
                                        }}
                                    >

                                        Sort Order

                                    </th>


                                    <th
                                        className="
                                            text-center
                                        "
                                        style={{
                                            minWidth:
                                                "180px"
                                        }}
                                    >

                                        Action

                                    </th>

                                </tr>

                            </thead>


                            <tbody>

                                {questions.length > 0 ? (

                                    questions.map(
                                        (
                                            item,
                                            index
                                        ) => {

                                            const questionText =
                                                getText(
                                                    item.question
                                                );


                                            const isSelected =
                                                selectedQuestions.includes(
                                                    item.question_id
                                                );


                                            return (

                                                <tr
                                                    key={
                                                        item.question_id ||
                                                        index
                                                    }
                                                    className={
                                                        isSelected
                                                            ? "table-primary"
                                                            : ""
                                                    }
                                                >

                                                    <td
                                                        className="
                                                            text-center
                                                        "
                                                    >

                                                        <input
                                                            type="checkbox"
                                                            className="
                                                                form-check-input
                                                            "
                                                            checked={
                                                                isSelected
                                                            }
                                                            onChange={() =>
                                                                handleQuestionSelect(
                                                                    item.question_id
                                                                )
                                                            }
                                                        />

                                                    </td>


                                                    <td
                                                        className="
                                                            text-center
                                                        "
                                                    >

                                                        {
                                                            startNumber +
                                                            index
                                                        }

                                                    </td>


                                                    <td
                                                        className="
                                                            text-center
                                                        "
                                                    >

                                                        <span
                                                            className="
                                                                badge
                                                                bg-light
                                                                text-dark
                                                                border
                                                            "
                                                        >

                                                            {
                                                                item.Q_number ||
                                                                "-"
                                                            }

                                                        </span>

                                                    </td>


                                                    
                                                    <td>
                                                        <div
                                                            title={questionText || ""}
                                                            style={{
                                                                maxWidth: "500px",
                                                                maxHeight: "100px",
                                                                overflowY: "auto",
                                                                overflowX: "hidden",
                                                                whiteSpace: "normal",
                                                                overflowWrap: "anywhere",
                                                                lineHeight: "1.5"
                                                            }}
                                                            dangerouslySetInnerHTML={{
                                                                __html: questionText || "-"
                                                            }}
                                                        />
                                                    </td>



                                                    <td>

                                                        <span
                                                            className="
                                                                badge
                                                                bg-primary
                                                            "
                                                        >

                                                            {
                                                                item.paper_type ||
                                                                "-"
                                                            }

                                                        </span>

                                                    </td>


                                                    <td>

                                                        {
                                                            item.paper ||
                                                            "-"
                                                        }

                                                    </td>


                                                    <td>

                                                        {
                                                            item.category ||
                                                            "-"
                                                        }

                                                    </td>


                                                    <td>

                                                        {
                                                            item.exam_date ||
                                                            "-"
                                                        }

                                                    </td>


                                                    <td
                                                        className="
                                                            text-center
                                                        "
                                                    >

                                                        {
                                                            item.sort_order ??
                                                            "-"
                                                        }

                                                    </td>


                                                    <td
                                                        className="
                                                            text-center
                                                        "
                                                    >

                                                        <div
                                                            className="
                                                                d-flex
                                                                justify-content-center
                                                                gap-1
                                                            "
                                                        >

                                                            {/* EDIT */}

                                                            <Link
                                                                to={
                                                                    `/edit-question/${encodeURIComponent(
                                                                        item.question_id
                                                                    )}`
                                                                }
                                                                className="
                                                                    btn
                                                                    btn-sm
                                                                    btn-outline-primary
                                                                "
                                                                title="
                                                                    Edit Question
                                                                "
                                                            >

                                                                <i
                                                                    className="
                                                                        fa
                                                                        fa-edit
                                                                        me-1
                                                                    "
                                                                ></i>

                                                                Edit

                                                            </Link>


                                                            {/* DELETE */}

                                                            <button
                                                                type="button"
                                                                className="
                                                                    btn
                                                                    btn-sm
                                                                    btn-outline-danger
                                                                "
                                                                title="
                                                                    Delete Question
                                                                "
                                                                disabled={
                                                                    transferLoading
                                                                }
                                                                onClick={() =>
                                                                    handleDeleteQuestion(
                                                                        item.question_id
                                                                    )
                                                                }
                                                            >

                                                                <i
                                                                    className="
                                                                        fa
                                                                        fa-trash
                                                                        me-1
                                                                    "
                                                                ></i>

                                                                Delete

                                                            </button>

                                                        </div>

                                                    </td>

                                                </tr>

                                            );

                                        }
                                    )

                                ) : (

                                    <tr>

                                        <td
                                            colSpan="10"
                                            className="
                                                text-center
                                                py-5
                                                text-muted
                                            "
                                        >

                                            <i
                                                className="
                                                    fa
                                                    fa-question-circle
                                                    fs-3
                                                    mb-3
                                                "
                                            ></i>


                                            <div>

                                                No questions found.

                                            </div>

                                        </td>

                                    </tr>

                                )}

                            </tbody>

                        </table>

                    </div>

                </div>


                {/* =====================================================
                    PAGINATION
                ===================================================== */}

                {totalQuestions > 0 && (

                    <div
                        className="
                            card-footer
                            bg-white
                        "
                    >

                        <div
                            className="
                                d-flex
                                justify-content-between
                                align-items-center
                                flex-wrap
                                gap-3
                            "
                        >


                            {/* SHOWING */}

                            <div
                                className="
                                    text-muted
                                "
                            >

                                Showing{" "}

                                <strong>
                                    {startNumber}
                                </strong>

                                {" "}to{" "}

                                <strong>
                                    {endNumber}
                                </strong>

                                {" "}of{" "}

                                <strong>
                                    {totalQuestions}
                                </strong>

                            </div>


                            {/* PAGINATION */}

                            <nav>

                                <ul
                                    className="
                                        pagination
                                        mb-0
                                    "
                                >

                                    {/* Previous */}

                                    <li
                                        className={`

                                            page-item

                                            ${
                                                currentPage === 1
                                                    ? "disabled"
                                                    : ""
                                            }

                                        `}
                                    >

                                        <button
                                            type="button"
                                            className="
                                                page-link
                                            "
                                            onClick={
                                                handlePrevious
                                            }
                                            disabled={
                                                currentPage === 1 ||
                                                loading
                                            }
                                        >

                                            Previous

                                        </button>

                                    </li>


                                    {/* Page Numbers */}

                                    {getPageNumbers().map(
                                        (
                                            page,
                                            index
                                        ) => {

                                            if (
                                                page === "..."
                                            ) {

                                                return (

                                                    <li
                                                        key={
                                                            `dots-${index}`
                                                        }
                                                        className="
                                                            page-item
                                                            disabled
                                                        "
                                                    >

                                                        <span
                                                            className="
                                                                page-link
                                                            "
                                                        >

                                                            ...

                                                        </span>

                                                    </li>

                                                );

                                            }


                                            return (

                                                <li
                                                    key={page}
                                                    className={`

                                                        page-item

                                                        ${
                                                            currentPage === page
                                                                ? "active"
                                                                : ""
                                                        }

                                                    `}
                                                >

                                                    <button
                                                        type="button"
                                                        className="
                                                            page-link
                                                        "
                                                        onClick={() =>
                                                            goToPage(
                                                                page
                                                            )
                                                        }
                                                        disabled={
                                                            loading
                                                        }
                                                    >

                                                        {
                                                            page
                                                        }

                                                    </button>

                                                </li>

                                            );

                                        }
                                    )}


                                    {/* Next */}

                                    <li
                                        className={`

                                            page-item

                                            ${
                                                currentPage >=
                                                totalPages
                                                    ? "disabled"
                                                    : ""
                                            }

                                        `}
                                    >

                                        <button
                                            type="button"
                                            className="
                                                page-link
                                            "
                                            onClick={
                                                handleNext
                                            }
                                            disabled={

                                                currentPage >=
                                                totalPages ||

                                                loading

                                            }
                                        >

                                            Next

                                        </button>

                                    </li>

                                </ul>

                            </nav>

                        </div>

                    </div>

                )}

            </div>

        </div>

    );

}


export default Questions;